import { render, staticRenderFns } from "./SelectListsOfFriends.vue?vue&type=template&id=380a5173&scoped=true&"
import script from "./SelectListsOfFriends.vue?vue&type=script&lang=js&"
export * from "./SelectListsOfFriends.vue?vue&type=script&lang=js&"
import style0 from "./SelectListsOfFriends.vue?vue&type=style&index=0&id=380a5173&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a5173",
  null
  
)

export default component.exports